import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled, { keyframes } from 'styled-components';
import Button from '../../../react-components/Button';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const StyledLoginButton = styled(Button)<{ isEnabled: boolean }>`
  font-size: 14px;
  font-weight: 600;
  background-color: ${RoutalPalette.primary40};
  transition: opacity 0.3s;
  opacity: ${(props) => (props.isEnabled ? `1` : `0`)};
  visibility: ${(props) => (props.isEnabled ? `visible` : `hidden`)};
  animation: ${(props) => (props.isEnabled ? fadeIn : fadeOut)} 0.3s ease-in-out;
`;
